// بيانات صفحة اتصل بنا
export const contactData = {
  // معلومات الاتصال
  phone: "213-0657362317",
  whatsappNumber: "2130657362317",
  email: "contact@moda-lady.shop",
  facebookUrl: "https://www.facebook.com/share/17XVHkTcs6/",

  // العنوان
  address: "الجزائر",
  fullAddress: "مركز التوزيع الرئيسي، الجزائر",

  // ساعات العمل
  workingHours: "السبت - الخميس: 9:00 ص - 6:00 م",

  // رسالة واتساب ترحيبية
  whatsappWelcomeMessage: "مرحباً moda-lady! أريد الاستفسار عن تشكيلة الملابس النسائية",

  // رسالة نموذج الاتصال
  contactFormMessage: "رسالة جديدة من موقع moda-lady"
};

// دالة لإنشاء رسالة واتساب ترحيبية
export const createWelcomeWhatsappMessage = () => {
  const message = contactData.whatsappWelcomeMessage;
  return encodeURIComponent(message);
};

// دالة لإنشاء رابط واتساب ترحيبي
export const createWelcomeWhatsappUrl = () => {
  const message = createWelcomeWhatsappMessage();
  return `https://wa.me/${contactData.whatsappNumber}?text=${message}`;
};

// دالة لإنشاء رسالة نموذج الاتصال
export const createContactFormMessage = (formData) => {
  const message = `${contactData.contactFormMessage}
الاسم: ${formData.name}
البريد الإلكتروني: ${formData.email}
الرسالة: ${formData.message}`;

  return encodeURIComponent(message);
};

// دالة لإنشاء رابط واتساب لنموذج الاتصال
export const createContactFormWhatsappUrl = (formData) => {
  const message = createContactFormMessage(formData);
  return `https://wa.me/${contactData.whatsappNumber}?text=${message}`;
};
